import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";
import CountriesMenu from "./Countries";
import { useGetModelsService } from "@hooks";
import { SelectedCountry } from "../CityBar";

interface LeftPanelProps {
  onCloseMobileMenu?: () => void;
  onCountrySelect?: (c: SelectedCountry) => void;
  showSearch?: boolean;
}

const norm = (s: string) =>
  s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

const LeftPanel: React.FC<LeftPanelProps> = ({
  onCloseMobileMenu,
  onCountrySelect,
  showSearch = false,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { handleGetModels, homeModels } = useGetModelsService();
  const [q, setQ] = useState("");

  const handleGetModelsClick = async () => {
    await handleGetModels();
    onCloseMobileMenu?.();
  };

  const matches = useMemo(() => {
    const n = norm(q);
    if (!showSearch || !n) return [];
    return homeModels
      .filter((m: any) => norm(m.fullname || "").includes(n))
      .slice(0, 8);
  }, [q, homeModels, showSearch]);

  const openModel = (topic: string) => {
    setQ("");
    onCloseMobileMenu?.();
    navigate(`/show/${topic}`);
  };

  return (
    <Box className={classes.leftPanel}>
      <h1 className={classes.logo} onClick={handleGetModelsClick}>
        <span className={classes.logoText}>
          Best<br /><span className={classes.logoRed}>Euro</span><br />Girls
        </span>
        <img src="/img/logo-silueta.webp" alt="Best Euro Girls" width="260" height="579" />
      </h1>
      {showSearch && (
        <Box sx={{ p: "10px", borderBottom: "1px solid rgba(255,255,255,.08)" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.5,
              height: 40,
              borderRadius: "4px",
              border: "1px solid rgba(212,22,60,.55)",
              bgcolor: "rgba(212,22,60,.12)",
            }}
          >
            <Box
              component="input"
              value={q}
              placeholder="Search country or model"
              onChange={(e: any) => setQ(e.target.value)}
              onKeyDown={(e: any) => {
                if (e.key === "Escape") setQ("");
              }}
              sx={{
                flex: 1,
                minWidth: 0,
                bgcolor: "transparent",
                border: 0,
                outline: 0,
                color: "#fff",
                fontSize: 14,
                "&::placeholder": { color: "rgba(255,255,255,.6)" },
              }}
            />
            <SearchIcon sx={{ color: "#fff", fontSize: 20 }} />
          </Box>
        </Box>
      )}
      {matches.length > 0 && (
        <Box sx={{ borderBottom: "1px solid rgba(255,255,255,.08)", pb: 0.5 }}>
          <Box sx={{ px: 1.5, pt: 1.25, pb: 0.5, color: "#d4163c", fontWeight: 700, fontSize: 13, letterSpacing: ".04em" }}>
            MODELS
          </Box>
          {matches.map((m: any) => (
            <Box
              key={m.id}
              onClick={() => openModel(m.topic)}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 1,
                px: 1.5,
                py: 0.9,
                cursor: "pointer",
                color: "#e8e8ec",
                fontSize: 14,
                "&:hover": { bgcolor: "rgba(255,255,255,.06)" },
              }}
            >
              <span>{m.fullname}</span>
              <span style={{ color: "#8b93a5", fontSize: 12 }}>
                {m.contact?.city?.name ?? m.contact?.country?.name ?? ""}
              </span>
            </Box>
          ))}
        </Box>
      )}
      <CountriesMenu
        onSelect={() => onCloseMobileMenu?.()}
        onCountrySelect={onCountrySelect}
        filter={showSearch ? q : ""}
      />
    </Box>
  );
};

export { LeftPanel };
